module.exports = __webpack_public_path__ + "img/dark-dirt.15c3066b.png";